<template>
    <ReBModal ref="pagePdfViewer"
              header="图纸查看">
        <b-overlay :show="queryLoading" rounded="sm" style="min-height: 50px">
            <div class="d-flex flex-column">
                <div v-if="attachmentList.length>0">
                    <div v-if="drawingList.length>0" class="font-weight-bold">From Upload:</div>
                    <PdfFileList :attachments="attachmentList"
                                 @loading="pdfListLoading"></PdfFileList>
                </div>
                <div v-show="drawingList.length>0" class="mt-2">
                    <div v-if="attachmentList.length>0" class="font-weight-bold">From Config:</div>
                    <mini-table :items="drawingList"
                                :fields="drawingTableFields"
                                disable-first-index-column
                                read-only
                                custom-columns="originFileName">
                        <template #custom(originFileName)="{row,val}">
                            <b-link @click="downloadDrawing(row.id, val)">{{ val }}</b-link>
                        </template>
                    </mini-table>
                </div>
                <empty-list-info v-if="!queryLoading&&!hasSomething || !attachmentList && !material"></empty-list-info>
            </div>
        </b-overlay>
    </ReBModal>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import PdfFileList from "@/components/Pdf/PdfFileList.vue";
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo.vue";
import drawingDownloadMixin from "@/views/sithMesII/pds/stuffs/drawing-download-mixin";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "PdfDrawingsView",
    components: {MiniTable, EmptyListInfo, PdfFileList, ReBModal},
    mixins: [drawingDownloadMixin],
    props: {
        attachmentIds: String,
        material: String
    },
    data() {
        return {
            attachmentList: [],
            hasSomething: false,

            queryLoading: true,
            drawingList: [],

            drawingTableFields: [
                {key: 'originFileName', label: '文件名'},
                {key: 'description', label: '描述'},
            ],
            shouldQuery: false
        }
    },
    watch: {
        material: {
            handler() {
                if (this.shouldQuery) {
                    this.getDrawings();
                }
            },
            immediate: true
        },
        attachmentIds: {
            handler() {
                if (this.shouldQuery) {
                    this.getAttachments();
                }
            },
            immediate: true
        },
        shouldQuery() {
            if (this.shouldQuery) {
                this.getDrawings();
                this.getAttachments();
            }
        },
    },
    methods: {
        //控制图纸查看的modal的loading
        pdfListLoading(val) {
            this.$refs.pagePdfViewer && this.$refs.pagePdfViewer.changeLoading(val);
        },
        getAttachments() {
            if (this.attachmentList) {
                let url = process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/getAttachmentList?attachmentIds="
                    + this.attachmentIds;
                this.$store.dispatch('api/get', {
                    url: url
                }).then(response => {
                    if (response && response.length > 0) {
                        this.attachmentList = response;
                        this.hasSomething = true;
                    }
                }).finally(() => this.queryLoading = false);
            }
        },
        show() {
            this.shouldQuery = true;
            this.$refs.pagePdfViewer.showModal();
        },
        getDrawings() {
            if (this.material) {
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_SITHMESII_PDS_URL + "/materialDrawingRelate/query/drawing?material=" + this.material
                }).then(response => {
                    if (response && response.length > 0) {
                        this.drawingList = response;
                        this.hasSomething = true;
                    }
                }).finally(() => this.queryLoading = false);
            }
        },
    }
}

</script>

<style scoped>

</style>
